import mixpanel from "mixpanel-browser";

const MIXPANEL_TOKEN = "528336c4510157730007ae5e98b0d633";

export const initAnalytics = () => {
  mixpanel.init(MIXPANEL_TOKEN, {
    track_pageview: false,
    autocapture: true,
    record_sessions_percent: 25,
    api_host: 'https://api-eu.mixpanel.com',
  });
  // signup_flow_version lets Mixpanel funnels separate the three-step
  // business sign-up (3) from the earlier five-step flow.
  mixpanel.register({ platform: "web", signup_flow_version: 3 });
};

export const identify = (email) => {
  try {
    mixpanel.identify(email);
    mixpanel.people.set({ $email: email });
  } catch (e) {
    console.warn("[analytics] identify failed:", e);
  }
};

export const track = (event, properties = {}) => {
  try {
    mixpanel.track(event, properties);
  } catch (e) {
    console.warn("[analytics] track failed:", e);
  }
};

// Call before hard navigations (window.location.href = ...) to give the
// SDK a chance to flush its queue before the page unloads.
export const flushAnalytics = () => {
  try {
    if (typeof mixpanel.flush === "function") mixpanel.flush();
  } catch (e) {
    // flush not available in all SDK versions; sendBeacon on unload is the fallback
  }
};

// Call on sign-out to prevent the next user on the same device inheriting
// this session's identity. Wire up when a logout flow is added.
export const resetAnalytics = () => {
  try {
    mixpanel.reset();
  } catch (e) {
    console.warn("[analytics] reset failed:", e);
  }
};
